import { useMemo } from 'react';
import { ERROR_MAPPING } from 'Modules/fortiva/config/appStatusMap';

/**
 * Hook that extracts error configuration from an application object
 * @param {Object} application - The application object
 * @returns {Object} errorConfig - Object containing error type, status, message, errorCode, and affected fields
 */
export const useGetErrorConfig = (application) => {
  return useMemo(() => {
    if (!application || !application.payload || !application.payload.correction_required) {
      return {
        type: 'GENERIC',
        status: '',
        message: '',
        errorCode: null,
        affectedFields: [],
      };
    }

    const { status = '', message = '' } = application.payload.correction_required;

    // Extract error code from message if it exists in curly braces
    const errorCodeMatch = message.match(/\{([^}]+)\}/);
    const errorCode = errorCodeMatch ? errorCodeMatch[1] : null;

    // Clean the message by removing the error code part
    const cleanMessage = errorCode ? message.replace(/\{[^}]+\}\s*/, '').trim() : message;

    const error = ERROR_MAPPING.find((e) => e.status === status && e.message === cleanMessage);
    const errorType = error?.errorType || 'GENERIC';

    return {
      type: errorType,
      status,
      message: cleanMessage ? cleanMessage : message,
      errorCode,
      affectedFields: error?.affectedFields || [],
    };
  }, [application]);
};
